import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function Header() {
  const loc = useLocation();
  const navItem = (to, label, testId) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testId}
        className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
          active
            ? "text-[var(--brand-primary)] bg-[var(--brand-primary)]/8"
            : "text-[var(--text-secondary)] hover:text-[var(--brand-primary)] hover:bg-[var(--bg-tint)]"
        }`}
      >
        {label}
      </Link>
    );
  };

  return (
    <header
      className="sticky top-0 z-30 bg-white/95 backdrop-blur-xl border-b border-[var(--border-default)]"
      data-testid="app-header"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-3.5 flex items-center justify-between gap-6">
        <Link
          to="/"
          className="flex items-center gap-2.5 group"
          data-testid="header-logo-link"
        >
          <div className="transition-transform group-hover:rotate-12 duration-300">
            <BrandLogo size={38} />
          </div>
          <div className="leading-none">
            <div className="font-heading font-bold text-[16px] tracking-tight text-[var(--text-primary)]">
              ITHR <span className="gradient-text">TalentLens</span>
            </div>
            <div className="font-mono text-[9.5px] uppercase tracking-[0.18em] text-[var(--text-muted)] mt-1">
              See talent clearly · v1.4
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItem("/", "Dashboard", "nav-dashboard-link")}
          <a
            href="#process"
            data-testid="nav-process-link"
            className="px-3 py-2 text-sm font-medium rounded-md text-[var(--text-secondary)] hover:text-[var(--brand-primary)] hover:bg-[var(--bg-tint)] transition-colors"
          >
            Workflow
          </a>
          <a
            href="#features"
            data-testid="nav-features-link"
            className="px-3 py-2 text-sm font-medium rounded-md text-[var(--text-secondary)] hover:text-[var(--brand-primary)] hover:bg-[var(--bg-tint)] transition-colors"
          >
            Capabilities
          </a>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <div className="flex items-center gap-1.5 text-xs text-[var(--brand-success)]">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
            </span>
            <span className="font-medium">In Focus</span>
          </div>
          <span className="corp-badge success" data-testid="header-badge">
            <ShieldCheck className="w-3 h-3" strokeWidth={2.5} />
            GDPR Safe
          </span>
        </div>
      </div>
    </header>
  );
}
